import Form from 'components/Form';
import { IFormRegister, IFormWatch, IFormValues } from 'routes/Main/type';

import { Grid, Box, MenuItem } from '@mui/material';
import { MobileTimePicker } from '@mui/x-date-pickers';
import { AccessTime } from '@mui/icons-material';

import MuiTextField from 'components/Form/MuiTextField';

import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';
import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormRegister, IFormWatch, IFormValues {
  disabled?: boolean;
}

const EmergencyRecord = (props: Props) => {
  const { disabled, register, watch, getValues, setValue } = props;

  const timePickers = [
    {
      title: '事故时间',
      variable: 'emergency_information.accident_time',
    },
    { title: '到达时间', variable: 'emergency_information.arrival_time' },
  ];

  return (
    <>
      <SectionTitle title="转移摘要" />
      <RowContainer xs={12}>
        <RowContent title="事故日期" titleRatio={1} childrenRatio={2}>
          <Form.MuiTextField
            type="date"
            InputLabelProps={{ shrink: true }}
            required={false}
            disabled={disabled}
            {...register('emergency_information.accident_date')}
          />
        </RowContent>
        {timePickers.map(({ title, variable }, _) => (
          <RowContent
            key={variable}
            title={title}
            titleRatio={1}
            childrenRatio={2}
          >
            <MobileTimePicker
              disabled={disabled}
              value={watch(variable) || null}
              onChange={value => setValue(variable, value)}
              renderInput={params => (
                <MuiTextField
                  {...params}
                  required={false}
                  placeholder="00:00"
                  InputProps={{ endAdornment: <AccessTime /> }}
                />
              )}
            />
          </RowContent>
        ))}
        <RowContent title="到达方式" titleRatio={1} childrenRatio={2}>
          <Box display="flex">
            <Form.MuiTextField
              select
              required={false}
              disabled={disabled}
              defaultValue={getValues('emergency_information.visit_method')}
              {...register('emergency_information.visit_method')}
            >
              <MenuItem value="ambulance">步行</MenuItem>
              <MenuItem value="stretcher">担架</MenuItem>
              <MenuItem value="wx">轮椅</MenuItem>
              <MenuItem value="police">警察</MenuItem>
              <MenuItem value="medics">医护人员</MenuItem>
            </Form.MuiTextField>
          </Box>
        </RowContent>
        <Grid item xs={12}>
          <Form.MuiTextField
            multiline
            minRows={8}
            disabled={disabled}
            required={false}
            {...register('emergency_information.memo')}
            placeholder={'主诉'}
          />
        </Grid>
      </RowContainer>
    </>
  );
};

export default EmergencyRecord;
